import ItemsGridWithSidebar from './itemsGridWithSidebar'

export default ItemsGridWithSidebar
